import { Mapper } from "../../../../base/utils/mapper";
import { DevelopmentResponseModel } from "../../../../domain/models/consult/development-response.model";
export class DevelopmentImplementationRepositoryMapper extends Mapper<DevelopmentResponseModel, DevelopmentResponseModel> {
    mapFrom(param: DevelopmentResponseModel): DevelopmentResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: DevelopmentResponseModel): DevelopmentResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}